//@flow
import * as React from 'react'
import type { ContainerRowInstructionLink$Props } from './flowTypes'

const ContainerRowInstructionLink=(props:ContainerRowInstructionLink$Props)=>{
    return (
        <div className="row">
            <div className="col-sm">
                <a href={props.instructionLink} target='_blank' >Instructions</a>
                &nbsp;&nbsp;&nbsp;
                <a href={props.docLink} target='_blank' >PDF Link</a>
                <br />
                <br />
            </div>
        </div> 
    )
}

export default ContainerRowInstructionLink


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowInstructionLink.js